const getCodeByISOCode = (items = [], value) =>
  items.find((i) => i.iso1Code === value)?.phoneCode;

export default getCodeByISOCode;
